function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from "react";
import { Form, Button, Input, Alert } from "antd";
import { UnlockFilled } from "@ant-design/icons";
import axios from 'axios';
import { Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Common from "../includes/Common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var UserLogin = function UserLogin() {
  var navigate = useNavigate();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    formLoading = _useState2[0],
    setFormLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFormError = _useState4[0],
    setIsFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var onFinish = function onFinish(values) {
    setFormLoading(true);
    setIsFormError(false);
    var formData = new FormData();
    formData.append('mobile', values.mobile);
    formData.append('password', values.password);
    axios.post(Common.baseApiUrl + 'login', formData).then(function (result) {
      setFormLoading(false);
      var data = result['data'];
      if (data['status'] == 200) {
        var usr = data['user'];
        localStorage.removeItem('userData');
        localStorage.setItem('userData', JSON.stringify(usr));
        localStorage.setItem('isOn', true);
        localStorage.setItem("businessData", JSON.stringify(data['businessAccount']));
        localStorage.setItem('menu_key', 'dash');
        switch (usr.role) {
          case 501:
            navigate('/home/agent');
            location.reload();
            break;
          case 601:
            navigate('/home/cashier');
            location.reload();
            break;
          case 701:
            navigate('/home/dashboard');
            location.reload();
            break;
          case 801:
            navigate('/home/dashboard');
            location.reload();
            break;
          case 901:
            navigate('/home/dashboard');
            location.reload();
            break;
          default:
            setErrorMessage("Vous n'avez pas autorisation d'accès à cet espace");
            setIsFormError(true);
        }
      } else {
        setErrorMessage(data['message']);
        setIsFormError(true);
      }
    });
  };
  var onFinishFailed = function onFinishFailed(errorInfo) {
    //console.log('Failed:', errorInfo);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        fontSize: '17px',
        padding: '10px 0px'
      },
      children: [/*#__PURE__*/_jsx(UnlockFilled, {}), " ", /*#__PURE__*/_jsx("b", {
        children: "StationSuite"
      }), " By ", /*#__PURE__*/_jsx("b", {
        children: "Guisoft Lab"
      }), ", Gestion \xE9fficace de stations"]
    }), /*#__PURE__*/_jsxs(Form, {
      name: "ulogin",
      size: "large",
      layout: "vertical",
      initialValues: {
        remember: true
      },
      onFinish: onFinish,
      onFinishFailed: onFinishFailed,
      autoComplete: "off",
      children: [/*#__PURE__*/_jsx(Form.Item, {
        label: "ID",
        name: "mobile",
        rules: [{
          required: true,
          message: 'Enter votre numero mobile'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Mot de passe",
        name: "password",
        rules: [{
          required: true,
          message: 'Le mot de passe est obligatoire !'
        }],
        children: /*#__PURE__*/_jsx(Input.Password, {})
      }), isFormError ? /*#__PURE__*/_jsx(Alert, {
        style: {
          marging: '5px 0px',
          fontSize: '14px'
        },
        message: errorMessage,
        type: "error",
        showIcon: true
      }) : /*#__PURE__*/_jsx("span", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form.Item, {
        children: [/*#__PURE__*/_jsx(Button, {
          type: "default",
          size: "middle",
          htmlType: "submit",
          children: /*#__PURE__*/_jsx("b", {
            children: "Se connecter"
          })
        }), formLoading ? /*#__PURE__*/_jsx(Spinner, {
          animation: "grow",
          variant: "warning"
        }) : /*#__PURE__*/_jsx("span", {})]
      })]
    })]
  });
};
export default UserLogin;